import { useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ForgotPassword(): JSX.Element {
  const [step, setStep] = useState<number>(1);
  const [email, setEmail] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSendEmail = async (): Promise<void> => {
    setError("");
    try {
      const res = await fetch("https://nrimarriage.in/api/v1/Users/ForgotPassword", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setStep(2);
      } else {
        setError(data.message || "Failed to send OTP");
      }
    } catch (err) {
      setError("An error occurred while sending the OTP.");
    }
  };

  const handleVerifyOtp = async (): Promise<void> => {
    try {
      const res = await fetch("https://nrimarriage.in/api/v1/Users/VerifyOTP", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const data = await res.json();
      if (res.ok) {
        setStep(3);
      } else {
        alert(data.message || "OTP verification failed.");
      }
    } catch {
      alert("An error occurred while verifying OTP.");
    }
  };

  const handleResetPassword = async (): Promise<void> => {
    setError("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    try {
      const res = await fetch("https://nrimarriage.in/api/v1/Users/ResetPassword", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp, newPassword }),
      });

      const data = await res.json();
      if (res.ok) {
        alert("Password reset successful!");
        navigate("/login");
      } else {
        setError(data.message || "Password reset failed");
      }
    } catch {
      setError("An error occurred while resetting the password.");
    }
  };

  return (
    <div className="body100">
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="card p-4 shadow-lg" style={{ width: "400px" }}>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            {step === 1 && (
              <>
                <h2 className="mb-3">Forgot Password</h2>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                  />
                </div>
                <button onClick={handleSendEmail} className="btn-primary1 w-100">
                  Send OTP
                </button>
              </>
            )}

            {step === 2 && (
              <>
                <h2 className="mb-3">Enter OTP</h2>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    value={otp}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setOtp(e.target.value)}
                    placeholder="Enter OTP"
                  />
                </div>
                <button onClick={handleVerifyOtp} className="btn-primary1 w-100">
                  Verify OTP
                </button>
              </>
            )}

            {step === 3 && (
              <>
                <h2 className="mb-3">Reset Password</h2>
                <div className="mb-3 input-group">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="form-control"
                    value={newPassword}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                  />
                  <button
                    className="btn-outline-secondary"
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? "Hide" : "Show"}
                  </button>
                </div>
                <div className="mb-3 input-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                  />
                  <button
                    className="btn-outline-secondary"
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? "Hide" : "Show"}
                  </button>
                </div>
                <button onClick={handleResetPassword} className="btn-primary1 w-100">
                  Reset Password
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
